import { videoUploadLimitError } from '@captionflow/shared';

/** Read only metadata before creating a project or sending any file bytes. */
export async function validateVideoUpload(file: File): Promise<number> {
  const sizeError = videoUploadLimitError(file.size);
  if (sizeError) throw new Error(sizeError);
  const durationMs = await new Promise<number>((resolve, reject) => {
    const video = document.createElement('video');
    const url = URL.createObjectURL(file);
    const finish = (duration?: number) => {
      clearTimeout(timer);
      video.onloadedmetadata = null;
      video.onerror = null;
      video.removeAttribute('src');
      video.load();
      URL.revokeObjectURL(url);
      if (duration === undefined) reject(new Error('Could not read the video duration. Choose a valid MP4, MOV or WebM video.'));
      else resolve(duration);
    };
    const timer = setTimeout(() => finish(), 15000);
    video.preload = 'metadata';
    video.onloadedmetadata = () => finish(video.duration * 1000);
    video.onerror = () => finish();
    video.src = url;
  });
  const error = videoUploadLimitError(file.size, durationMs);
  if (error) throw new Error(error);
  return durationMs;
}
